<template>
    <Card class="card" @submitted="updateProfileInformation">
        <template #title>
            Профиль пользователя
        </template>

        <template #content>

            <!-- Name -->
            <div class="field">
                <label for="name"><b>Имя</b></label>
                <!-- <InputText
                    id="name"
                    class="w-full"
                    :class="{'p-invalid': form.errors.name}"
                    type="text"
                    v-model="form.name"
                />
                <small v-if="form.errors.name" class="p-invalid">
                    {{ form.errors.name }}
                </small> -->
                <p>{{ form.name }} {{ form.last_name }}</p>
            </div>
            <div class="field">
                <label for="email"><b>E-mail</b></label>
                <!-- <InputText
                    id="email"
                    class="w-full"
                    :class="{'p-invalid': form.errors.email}"
                    type="email"
                    v-model="form.email"
                />
                <small v-if="form.errors.email" class="p-invalid">
                    {{ form.errors.email }}
                </small> -->
                <p>{{ form.email }}</p>
            </div>
            <div class="field">
                <label for="email"><b>Роль (права) в системе</b></label>
                <p>{{ form.role }}</p>
            </div>
            <div class="field">
                <Checkbox v-model="changePassword" :binary="true" />
                Изменить пароль
            </div>
            <div class="field" v-if="changePassword">
                <label for="password"><b>Пароль</b></label>
                <br>
                <InputText
                    type="password"
                    id="password"
                    v-model.trim="model.password"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': !model.password }"
                />
                <br>
                <small
                    class="p-invalid"
                    v-if="!model.password"
                >Password is required.</small>
                <small
                    class="p-invalid"
                    v-if="model.password && passwordError"
                >Пароль должен содержать 8 символов (заглавные буквы/цифры/спецсимволы).</small>
            </div>
        </template>

        <template #footer>
            <Button
                label="Сохранить"
                :loading="form.processing"
                @click="saveModel"
            />
        </template>
    </Card>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import FlashMessage from "../Services/FlashMessage";
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';

export default {
    layout: AppLayout,
    components: {
        Card,
        InputText,
        Button,
        Checkbox,
        "p-toast": Toast,
    },

    props: ['user'],
    mixins: [FlashMessage],
    data() {
        return {
            changePassword: false,
            form: this.$inertia.form({
                _method: 'PUT',
                name: this.user.name,
                last_name: this.user.last_name,
                email: this.user.email,
                role: this.getRoleName(this.user.role),
                photo: null,
            }),

            model: {
                name: this.user.name,
                email: this.user.email,
                role: this.user.role,
                password: null,
            },

            photoPreview: null,
            passwordError: false,
        }
    },

    methods: {
        getRoleName(code) {
            const roles = {
                admin: 'Администратор',
                service_admin: 'Администратор сервисов',
                manager: 'Менеджер по продажам',
                osp: 'ОСП',
                client: 'Клиент',
                pm: 'ПМ/АПМ',
            }

            return roles[code]
        },

        saveModel() {
            if (this.model.password && !this.model.password.match(/^(?=.*\d)(?=.*[!@#$%_^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/)) {
                this.passwordError = true

                return
            } else {
                this.passwordError = false
            }

            if (this.model) {
                this.$inertia.put(this.route('users.update', this.user.id), this.model, {
                    onSuccess: () => {
                        this.model = {};
                        this.changePassword = false;
                        this.passwordError = false;
                        this.$toast.add({severity: 'info', summary: 'Success', detail: 'Пароль успешно изменен!'});
                    }
                })
            }
        },

        updateProfileInformation() {
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0]
            }

            this.form.post(route('user-profile-information.update'), {
                errorBag: 'updateProfileInformation',
                preserveScroll: true,
                onSuccess: () => {
                    this.flashSuccess('Zapisano dane konta.');
                }
            });
        },

        selectNewPhoto() {
            this.$refs.photo.click();
        },

        updatePhotoPreview() {
            const photo = this.$refs.photo.files[0];

            if (!photo) return;

            const reader = new FileReader();

            reader.onload = (e) => {
                this.photoPreview = e.target.result;
            };

            reader.readAsDataURL(photo);
        },

        deletePhoto() {
            this.$inertia.delete(route('current-user-photo.destroy'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.photoPreview = null;
                    this.clearPhotoFileInput();
                },
            });
        },

        clearPhotoFileInput() {
            if (this.$refs.photo?.value) {
                this.$refs.photo.value = null;
            }
        },
    },
}
</script>